import type {Table as ReactTable} from '@tanstack/react-table';

import SearchInput from '@/components/search/SearchInput';

interface TableSearchProps<TData> {
  table: ReactTable<TData>;
  description?: string;
  placeholder?: string;
}

function TableSearch<TData>({
  table,
  description,
  placeholder,
}: TableSearchProps<TData>) {
  return (
    <SearchInput
      description={description}
      placeholder={placeholder}
      value={(table.getState().globalFilter as string) ?? ''}
      onChange={value => {
        table.setGlobalFilter(value);
      }}
    />
  );
}

export default TableSearch;
